import { createRouter, createWebHistory } from 'vue-router'
import { authGuard } from '@auth0/auth0-vue'

/** PAGES */
import Login from '../pages/Login.vue'
import Dashboard from '../pages/Dashboard.vue'
import SearchCalls from '../pages/SearchCalls.vue'
import Users from '../pages/Users.vue'
import UserEdit from '../pages/UserEdit.vue'
import TenantEdit from '../pages/TenantEdit.vue'
import Reports from '../pages/Reports.vue'
import Tenants from '../pages/Tenants.vue'
import LCRs from '../pages/LCRs.vue'
import LCREdit from '../pages/LCREdit.vue'
import Tariffs from '../pages/Tariffs.vue'
import TariffEdit from '../pages/TariffEdit.vue'
import TariffProfiles from '../pages/TariffProfiles.vue'
import TariffProfileEdit from '../pages/TariffProfileEdit.vue'
import TariffCodes from '../pages/TariffCodes.vue'
import PhoneNumbers from '../pages/PhoneNumbers.vue'
import PhoneNumberEdit from '../pages/PhoneNumberEdit.vue'
import SIPTrunks from '../pages/SIPTrunks.vue'
import SIPTrunkEdit from '../pages/SIPTrunkEdit.vue'
import SIMs from '../pages/SIMs.vue'
import SIMsEdit from '../pages/SIMsEdit.vue'
import FeatureCodes from '../pages/FeatureCodes.vue'
import FeatureCodeEdit from '../pages/FeatureCodeEdit.vue'
import Resellers from '../pages/Resellers.vue'
import ResellerEdit from '../pages/ResellerEdit.vue'
import Carriers from '../pages/Carriers.vue'
import CarrierEdit from '../pages/CarrierEdit.vue'
import Accounts from '../pages/Accounts.vue'
import AccountEdit from '../pages/AccountEdit.vue'
import Realtime from '../pages/Realtime.vue'
import FlowEdit from '../pages/FlowEdit.vue'
import Flows from '../pages/Flows.vue'
import FileBrowser from '../pages/FileBrowser.vue'
import Porting from '../pages/Porting.vue'
import PortingEdit from '../pages/PortingEdit.vue'
import Devices from '../pages/Devices.vue'
import DeviceEdit from '../pages/DeviceEdit.vue'
import DeviceTemplateEdit from '../pages/DeviceTemplateEdit.vue'

const routes = [
	{
		path: '/dashboard',
		name: 'home',
		component: Dashboard,
		beforeEnter: authGuard,
		meta: {
			title: 'Dashboard'
		}
	},
	{
		path: '/calls',
		name: 'calls',
		component: SearchCalls,
		beforeEnter: authGuard,
		meta: {
			title: 'Search Calls'
		}
	},
	{
		path: '/signup',
		name: 'signup',
		component: Login,
		meta: {
			title: 'Login'
		}
	},
	{
		path: '/tariffcodes',
		name: 'tariffcodes',
		component: TariffCodes,
		beforeEnter: authGuard,
		meta: {
			title: 'Zones'
		}
	},
	{
		path: '/resellers',
		name: 'resellers',
		component: Resellers,
		beforeEnter: authGuard,
		meta: {
			title: 'Resellers'
		}
	},
	{
		path: '/resellers/:id',
		name: 'reselleredit',
		component: ResellerEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'Reseller Edit'
		}
	},
	{
		path: '/tenants',
		name: 'tenants',
		component: Tenants,
		beforeEnter: authGuard,
		meta: {
			title: 'Tenants'
		}
	},
	{
		path: '/tenants/:id',
		name: 'tenantedit',
		component: TenantEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'Tenant Edit'
		}
	},
	{
		path: '/lcrs',
		name: 'lcrs',
		component: LCRs,
		beforeEnter: authGuard,
		meta: {
			title: 'LCRs'
		}
	},
	{
		path: '/lcrs/:id',
		name: 'lcredit',
		component: LCREdit,
		beforeEnter: authGuard,
		meta: {
			title: 'LCR Edit'
		}
	},
	{
		path: '/tariffs',
		name: 'tariffs',
		component: Tariffs,
		beforeEnter: authGuard,
		meta: {
			title: 'Tariffs'
		}
	},
	{
		path: '/tariffs/:id',
		name: 'tariffedit',
		component: TariffEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'Tariff Edit'
		}
	},
	{
		path: '/tariffprofiles',
		name: 'tariffprofiles',
		component: TariffProfiles,
		beforeEnter: authGuard,
		meta: {
			title: 'Routes'
		}
	},
	{
		path: '/tariffprofiles/:id',
		name: 'tariffprofileedit',
		component: TariffProfileEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'Route Edit'
		}
	},
	{
		path: '/users',
		name: 'users',
		component: Users,
		beforeEnter: authGuard,
		meta: {
			title: 'Users'
		}
	},
	{
		path: '/users/:id',
		name: 'useredit',
		component: UserEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'User Edit'
		}
	},
	{
		path: '/flows',
		name: 'flows',
		component: Flows,
		beforeEnter: authGuard,
		meta: {
			title: 'Flows'
		}
	},
	{
		path: '/flows/:id',
		name: 'flowedit',
		component: FlowEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'Flow Edit'
		}
	},
	{
		path: '/reports',
		name: 'reports',
		component: Reports,
		beforeEnter: authGuard,
		meta: {
			title: 'Reports'
		}
	},
	{
		path: '/phonenumbers/:id',
		name: 'phonenumberedit',
		component: PhoneNumberEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'Phone Number Edit'
		}
	},
	{
		path: '/phonenumbers',
		name: 'phonenumbers',
		component: PhoneNumbers,
		beforeEnter: authGuard,
		meta: {
			title: 'Phone Numbers'
		}
	},
	{
		path: '/siptrunks/:id',
		name: 'siptrunkedit',
		component: SIPTrunkEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'SIP Trunk Edit'
		}
	},
	{
		path: '/featurecodes/:id',
		name: 'featurecodeedit',
		component: FeatureCodeEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'Feature Code Edit'
		}
	},
	{
		path: '/featurecodes',
		name: 'featurecodes',
		component: FeatureCodes,
		beforeEnter: authGuard,
		meta: {
			title: 'Feature Codes'
		}
	},
	{
		path: '/mobilesims',
		name: 'mobilesims',
		component: SIMs,
		beforeEnter: authGuard,
		meta: {
			title: 'SIMs'
		}
	},
	{
		path: '/mobilesims/:id',
		name: 'mobilesimedit',
		component: SIMsEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'SIM Edit'
		}
	},
	{
		path: '/siptrunks',
		name: 'siptrunks',
		component: SIPTrunks,
		beforeEnter: authGuard,
		meta: {
			title: 'SIP Trunks'
		}
	},
	{
		path: '/carriers/:id',
		name: 'carrieredit',
		component: CarrierEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'Carrier Edit'
		}
	},
	{
		path: '/carriers',
		name: 'carriers',
		component: Carriers,
		beforeEnter: authGuard,
		meta: {
			title: 'Carriers'
		}
	},
	{
		path: '/accounts/:id',
		name: 'accountedit',
		component: AccountEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'Account Edit'
		}
	},
	{
		path: '/accounts',
		name: 'accounts',
		component: Accounts,
		beforeEnter: authGuard,
		meta: {
			title: 'Accounts'
		}
	},
	{
		path: '/files',
		name: 'files',
		component: FileBrowser,
		beforeEnter: authGuard,
		meta: {
			title: 'File Browser'
		}
	},
	{
		path: '/realtime',
		name: 'realtime',
		component: Realtime,
		beforeEnter: authGuard,
		meta: {
			title: 'Realtime'
		}
	},
	{
		path: '/porting',
		name: 'porting',
		component: Porting,
		beforeEnter: authGuard,
		meta: {
			title: 'Porting'
		}
	},
	{
		path: '/porting/:id',
		name: 'portingedit',
		component: PortingEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'Porting Request'
		}
	},
	{
		path: '/devices',
		name: 'devices',
		component: Devices,
		beforeEnter: authGuard,
		meta: {
			title: 'Devices'
		}
	},
	{
		path: '/devices/:id',
		name: 'deviceedit',
		component: DeviceEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'Device Edit'
		}
	},
	{
		path: '/devicetemplates/:id',
		name: 'devicetemplateedit',
		component: DeviceTemplateEdit,
		beforeEnter: authGuard,
		meta: {
			title: 'Provisioning Template Edit'
		}
	},
	{
		path: '/:catchAll(.*)',
		redirect: '/dashboard',
		beforeEnter: authGuard,
		meta: {
			title: 'Dashboard'
		}
	}
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior() {
		return { x: 0, y: 0 }
	}
})

router.afterEach((to) => {
	document.title = to?.meta?.title ? `${to.meta.title} | TeleFlow` : 'TeleFlow'
	window.scrollTo(0, 0)
})

export { router }
